/**
 * 기본 URL과 Param 배열을 받아 완전한 URL을 생성합니다.
 *
 * @param {string} baseUrl - 쿼리 스트링을 추가할 기본 URL.
 * @param {InputData[]} params - { label, key, value } 형태의 객체 배열.
 * value 또는 value 배열의 요소가 빈 문자열('')인 경우는 무시됩니다.
 * (JSDoc에는 null이 언급되었으나, 현재 타입은 null을 허용하지 않습니다.
 * 만약 null 가능성이 있다면, 타입을 `string | string[] | null`로 변경해야 합니다.)
 * 동일한 key를 가진 여러 객체가 있으면, 해당 key로 여러 번 추가됩니다.
 * @returns {string} - 쿼리 스트링이 추가된 완전한 URL.
 */
export function createUrlWithQueryByInputItem(baseUrl, params) {
    const searchParams = new URLSearchParams();
    params.forEach((param) => {
        const key = param.key;
        const value = param.value;
        if (!key || value === null || value === undefined) {
            return; // 또는 continue;
        }
        // value가 배열인 경우 처리
        if (key === "issue_date") {
            if (Array.isArray(value) && value.length === 2) {
                const [startDate, endDate] = value;
                if (startDate && endDate) {
                    searchParams.append("issue_start_date", startDate);
                    searchParams.append("issue_end_date", endDate);
                }
            }
        }
        else if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => {
                if (typeof item === "string" && item !== "") {
                    searchParams.append(key, item);
                }
            });
        }
        else if (Array.isArray(value)) {
            value.forEach((item) => {
                if (typeof item === "string" && item !== "") {
                    searchParams.append(key, item);
                }
            });
        }
        // value가 단일 문자열인 경우
        else if (typeof value === "string" && value !== "") {
            searchParams.append(key, value);
        }
    });
    const queryString = searchParams.toString();
    if (!queryString)
        return baseUrl;
    const separator = baseUrl.includes("?") ? "&" : "?";
    return `${baseUrl}${separator}${queryString}`;
}
export function createUrlWithQuery(baseUrl, params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (!key || value === null || value === undefined) {
            return;
        }
        searchParams.append(key, String(value));
    });
    const queryString = searchParams.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
